import React from 'react';
import styles from './ErrorMessage.module.css';

const ErrorMessage = ({ message, retry }) => {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <p className={styles.message}>{message || 'An error occurred. Please try again.'}</p>
      {retry && (
        <button className={styles.retryButton} onClick={retry}>
          Try Again
        </button>
      )}
    </div>
  );
};

export default ErrorMessage; 